import { render, staticRenderFns } from "./EditAccountSettings.vue?vue&type=template&id=a2929bb0&scoped=true&"
import script from "./EditAccountSettings.vue?vue&type=script&lang=js&"
export * from "./EditAccountSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditAccountSettings.vue?vue&type=style&index=0&id=a2929bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2929bb0",
  null
  
)

export default component.exports